var _style, _path, _path2, _line, _g, _circle, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloorball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke-width:25;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,45.947;}\n   ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M435.2,773.3L849.5,94c4.3-7,13.4-9.2,20.4-4.8l27.8,17.5c7,4.4,9,13.6,4.5,20.5L464,796.2",
    id: "path1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 416.7,761.7 63.4,45 c 0,0 -28.0426,36.86307 -42.1,51.6 -14.0574,14.73693 -33.6227,37.97767 -73.29335,57.643 -39.67064,19.66533 -62.30121,19.90264 -84.14083,20.42076 -21.83962,0.51812 -64.3451,-6.95637 -88.66249,-18.37385 C 167.58594,906.57243 150.78727,903.87248 122.5,850 c -10.54564,-24.94496 -10.49599,-50.0859 -0.89599,-67.4859 13.04095,-29.19128 56.02753,-26.09529 75.80069,-14.32213 19.77317,11.77316 85.84782,69.77847 141.97042,49.71743 C 395.49772,797.84836 416.7,761.7 416.7,761.7 Z",
    id: "path2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 706.2,
    y1: 339.6,
    x2: 742,
    y2: 362.7,
    id: "line2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(160.44123,-13.645926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 538.40002,
    y1: 777.90002,
    x2: 538.40002,
    y2: 777.90002,
    id: "line5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 593.5,
    y1: 777.90002,
    x2: 621,
    y2: 777.90002,
    id: "line6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 648.59998,
    y1: 777.90002,
    x2: 648.59998,
    y2: 777.90002,
    id: "line7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g11"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 536.90002,
    y1: 833.29999,
    x2: 536.90002,
    y2: 833.29999,
    id: "line9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 593.79999,
    y1: 833.29999,
    x2: 622.29999,
    y2: 833.29999,
    id: "line10"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 650.70001,
    y1: 833.29999,
    x2: 650.70001,
    y2: 833.29999,
    id: "line11"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g15"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 536.90002,
    y1: 888.59998,
    x2: 536.90002,
    y2: 888.59998,
    id: "line13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 593.79999,
    y1: 888.59998,
    x2: 622.29999,
    y2: 888.59998,
    id: "line14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 650.70001,
    y1: 888.59998,
    x2: 650.70001,
    y2: 888.59998,
    id: "line15"
  })))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 755.50732,
    cy: 819.71539,
    r: 127.6,
    id: "circle4"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 171.2749,
    y1: 790.80908,
    x2: 203.1586,
    y2: 812.69745,
    id: "line12"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 154.9895,
    y1: 813.47137,
    x2: 176.16876,
    y2: 827.35999,
    id: "line16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorball);
export default __webpack_public_path__ + "static/media/Floorball.411cfe3d.svg";
export { ForwardRef as ReactComponent };